<script lang="ts" setup>
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError,
})

definePageMeta({
  layout: 'blank',
})

const title = computed<string>(() => {
  const statusCode = props.error?.statusCode
  if (statusCode === 404) {
    return 'Page not found'
  } else if (statusCode === 500) {
    return 'Server error'
  }

  return 'Error'
})

useHead({ title })
</script>

<template>
  <div class="blueprint-entry">
    <div class="blueprint-entry-card text-center">
      <header class="entry-brand">
        <div>
          <small>{{ props.error?.statusCode }}</small>
          <h1>{{ title }}</h1>
        </div>
      </header>
      <p class="mb-6">{{ props.error?.message }}</p>
      <Button as="router-link" label="Go to Dashboard" to="/" />
    </div>
  </div>
</template>
